import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

import { StockFilterInputProps } from './types';

function StockFilterInput({
  className,
  label,
  errorMessage,
  ...props
}: StockFilterInputProps) {
  return (
    <Component>
      {label && <Label>{label}</Label>}
      <Input className={className} {...props} />
      {errorMessage && <Error>{errorMessage}</Error>}
    </Component>
  );
}

export default StockFilterInput;

const Component = styled.div`
  position: relative;
  width: 100%;
`;

const Label = styled.p`
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.blue100};
`;

const Input = styled.input`
  display: block;
  width: 100%;
  padding: 11px 15px 10px;
  height: 40px;
  font-size: 16px;
  line-height: 19px;
  background: ${(props) => props.theme.white_1};
  color: ${(props) => props.theme.black200};
  border: 1px solid ${(props) => props.theme.gray1000};
  border-radius: 6px;

  &::placeholder {
    color: ${(props) => props.theme.gray1500};
    opacity: 1;
  }
`;

const Error = styled.div`
  position: absolute;
  color: ${colors.red600};
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  bottom: -18px;
`;
